import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Alert, Button, Col, Form, Input, Modal, Row } from "antd";
import {
  sendNotification,
  validateEmail,
  USER_DISABLED,
  USER_DISABLED_CODE,
  USER_INACTIVE,
  USER_INACTIVE_CODE,
  USER_LOGIN_ATTEMPS_DISABLED_CODE,
  USER_LOGIN_TIME_ATTEMPS_DISABLED,
  USER_NOT_FOUND_RECOVERY,
  VERSION
} from "../../utils";
import {
  logout,
  recoveryPassword,
  restartRecovery,
  signin,
  cleanErrorMessage
} from "../../actions/AuthAction";

export class LoginModalGn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: ""
    };
  }

  handleOnInputChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    const { email, password } = this.state;
    const { intl } = this.props;
    e.preventDefault();
    if (!validateEmail(email)) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "empty_email_input" })
      );
      return;
    }
    if (password === "") {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "sign_in.password_notification" })
      );
      return;
    }
    this.props.signin({ email, password, fromSignUp: false });
  };

  componentWillUnmount() {
    this.props.cleanErrorMessage();
  }

  render() {
    const { email } = this.state;
    const {
      showModalSignIn,
      handleHiddenModalSignIn,
      // handleShowModalRegister,
      handleShowModalForgotPassword,
      intl,
      error,
      isFetching
    } = this.props;
    const hash = "#";

    return (
      <Modal
        visible={showModalSignIn}
        onCancel={handleHiddenModalSignIn}
        width={540}
        footer={null}
        centered
        destroyOnClose={true}
        bodyStyle={{
          backgroundColor: "#021F37",
          color: "#fff",
        }}
      >
        <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src='/gnbrands/gn-logo-and-brands.png' alt='gnbrands' style={{ width: 300 }} />
        </Row>
        <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '2.5em' }}>
          {intl.formatMessage({ id: "custom-welcome" })}
          {/* <img src='/gnbrands/texto-bienvenido-2.png' alt='gyn-brands' /> */}
        </Row>
        <Row>
          <Form
            layout={"vertical"}
            onSubmit={this.handleSubmit}
            id={"form-sign-in"}
          >
            <Form.Item>
              <label style={{ fontSize: 16, fontWeight: 400, color: "#FFF" }}>
                Email
              </label>
              <Input
                name="email"
                type="email"
                value={email}
                ref={input => {
                  this.emailRef = input;
                }}
                size={"large"}
                placeholder={intl.formatMessage({
                  id: "sign_in.input_email"
                })}
                style={{ height: 57 }}
                onChange={this.handleOnInputChange}
              />
            </Form.Item>
            <Form.Item>
              <label style={{ fontSize: 16, fontWeight: 400, color: "#FFF" }}>
                {intl.formatMessage({ id: "sign_in.label_pass" })}
              </label>
              <Input.Password
                name="password"
                size={"large"}
                placeholder={intl.formatMessage({ id: "sign_in.label_pass" })}
                style={{ height: 57 }}
                onChange={this.handleOnInputChange}
              />
            </Form.Item>
          </Form>
          <Col span={24} style={{ textAlign: "right" }}>
            <a
              onClick={() => {
                handleHiddenModalSignIn();
                handleShowModalForgotPassword();
              }}
              href={hash}
            >
              {intl.formatMessage({ id: "sign_in.forgot_pass" })}
            </a>
          </Col>
          <br />
          <br />
          <Button
            size={"large"}
            type={"primary"}
            block
            style={{ height: 57 }}
            loading={isFetching}
            form={"form-sign-in"}
            htmlType={"submit"}
          >
            {intl.formatMessage({ id: "sign_in.title" })}
          </Button>
        </Row>
        <br />

        <p style={{ textAlign: "center" }}>v{VERSION}</p>

        <div style={{ marginBottom: 10 }}>
          {error &&
            error.status !== USER_NOT_FOUND_RECOVERY &&
            error.status !== USER_DISABLED && (
              <Alert
                style={{ display: "flex", justifyContent: "center" }}
                message={
                  error && error.data && error.data.message <= 0
                    ? intl
                      .formatMessage({ id: "login_attemps_disable_user" })
                      .replace("#time", USER_LOGIN_TIME_ATTEMPS_DISABLED)
                    : error.data && error.data.message
                      ? intl
                        .formatMessage({ id: "login_not_valid" })
                        .replace("#attemps", error.data.message)
                      : intl
                        .formatMessage({ id: "login_not_valid" })
                        .slice(0, 33)
                }
                type="error"
              />
            )}
          {error &&
            error.status === USER_INACTIVE &&
            error.data.code === USER_INACTIVE_CODE && (
              <Alert
                style={{ display: "flex", justifyContent: "center" }}
                message={
                  intl.formatMessage({ id: "current_user_is_inactive" }) +
                  " " +
                  intl.formatMessage({
                    id: "current_user_is_inactive_contact"
                  })
                }
                type="error"
              />
            )}
          {error &&
            error.status === USER_DISABLED &&
            error.data.code === USER_DISABLED_CODE && (
              <Alert
                style={{ display: "flex", justifyContent: "center" }}
                message={
                  intl.formatMessage({ id: "current_user_is_disabled" }) +
                  " 23:59 hrs. " +
                  intl.formatMessage({ id: "from" }) +
                  " " +
                  error.data.message.replace(/"/g, "") +
                  ". " +
                  intl.formatMessage({
                    id: "current_user_is_disabled_contact"
                  })
                }
                type="error"
              />
            )}
          {error &&
            error.status === USER_DISABLED &&
            error.data.code === USER_LOGIN_ATTEMPS_DISABLED_CODE && (
              <Alert
                style={{ display: "flex", justifyContent: "center" }}
                message={intl
                  .formatMessage({ id: "login_attemps_disable_user" })
                  .replace("#time", error.data.message)}
                type="error"
              />
            )}
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.authUser.user,
    error: state.authUser.error,
    token: state.authUser.token,
    isFetching: state.authUser.isFetching,
    passRecovered: state.authUser.passRecovered
  };
};

const mapDispatchToProps = {
  signin,
  logout,
  recoveryPassword,
  restartRecovery,
  cleanErrorMessage
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginModalGn)))